import { Link } from "react-router-dom";
import { AlertTriangle, ArrowLeft } from "lucide-react";
import { PageLayout } from "@/components/PageLayout";
import { useSeo } from "@/lib/useSeo";

const SEO = {
    metaTitle: "Page Not Found | EasiLinked",
    metaDescription: "The page you requested could not be found.",
    noIndex: true,
};

export default function NotFoundPage() {
    useSeo(SEO);

    return (
        <PageLayout>
            <section className="mx-auto flex min-h-[70vh] max-w-2xl flex-col items-center justify-center px-5 py-40 text-center sm:px-8">
                <span className="grid h-14 w-14 place-items-center rounded-2xl border border-brand-line bg-brand-surface text-brand-accent">
                    <AlertTriangle className="h-6 w-6" />
                </span>
                <p className="mt-6 font-mono text-xs uppercase tracking-[0.24em] text-brand-muted">
                    Error 404
                </p>
                <h1 className="mt-4 font-heading text-4xl font-extrabold tracking-tight text-brand-text sm:text-5xl">
                    Page not found
                </h1>
                <p className="mt-5 max-w-md text-base leading-relaxed text-brand-muted">
                    The page you're looking for doesn't exist or may have moved.
                </p>
                <Link
                    to="/"
                    className="group mt-9 inline-flex items-center gap-2 rounded-control bg-brand-accent px-7 py-3.5 text-sm font-semibold text-brand-on-accent transition-colors duration-150"
                >
                    <ArrowLeft className="h-4 w-4 transition-colors duration-150" />
                    Back to homepage
                </Link>
            </section>
        </PageLayout>
    );
}
